/** Tipos de categoria financeira; entryType é o entry_type da API. */
export const ENTRY_TYPES = {
  revenue: { entryType: 1, label: 'Receita', plural: 'Receitas' },
  expense: { entryType: 0, label: 'Despesa', plural: 'Despesas' },
} as const;

export type EntryType = keyof typeof ENTRY_TYPES;
